import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { OverlayType } from "../../../vendor_core/core/src/server/data/ISpinData";
import { ICondition } from "../../../vendor_core/core/src/states/State";
import BBModel from '../model/BBModel';


export default class BBHasCascadeLockedCondition implements ICondition {
    public check(): boolean {
        return BBModel.hasOverlay(OverlayType.Locked)
    }
}
